<template>
  <div class="basemap-selector" :style="cssVars">
    <b-dropdown
      dropup
      text=""
      right
      class="basemap-selector__dropdown"
      toggle-class="basemap-selector__dropdown-toggle"
    >
      <div class="basemap-selector__dropdown-content">
        <b-dropdown-item
          v-for="style in basemaps"
          :key="'basemap_' + style.name"
          :class="{ 'basemap-item-selected': style.name === selectedBasemap }"
          :disabled="style.disabled"
          @click="$emit('set-basemap', style.name)"
        >
          <img class="basemap-selector__image" :alt="style" :src="getMapThumbImg(style)" />
        </b-dropdown-item>
      </div>
      <template #button-content>
        <img
          class="basemap-select-button-image"
          :alt="selectedBasemap"
          :src="getMapThumbImg(basemaps.find((b) => b.name === selectedBasemap))"
        />
      </template>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    // Array of { name, disabled }
    basemaps: {
      type: Array,
      default: () => [],
    },
    selectedBasemap: {
      type: String,
      required: true,
    },
    useMobileMapControls: {
      type: Boolean,
      required: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cssVars() {
      if (!this.rounded) {
        return {};
      }
      return `--border-radius: 4px;`;
    },
  },
  methods: {
    getMapThumbImg(style) {
      const thumbName = style.name.toLowerCase().replace(/ /g, '_');
      const thumbs = import.meta.glob('./assets/map-thumbs/*.png', {
        eager: true,
        import: 'default',
      });
      return thumbs[`./assets/map-thumbs/${thumbName}.png`];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.basemap-selector {
  pointer-events: all;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: var(--border-radius, 0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  .basemap-select-button-image {
    width: 28px;
    height: 28px;
    border-radius: 40px;
    object-fit: cover;
    border: 2px solid $gray-300;

    &:hover {
      border-radius: 4px;
      transform: scale(1.1);
      animation: expand 0.5s ease-out alternate none;
    }
  }

  ::v-deep {
    .dropdown-menu {
      height: 440px;
      width: 200px;
      overflow: auto;
      border-radius: var(--border-radius, 0);
      overflow: hidden;
      margin-bottom: 4px;

      .basemap-selector__dropdown-content {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        height: 440px;
        width: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 8px;
        }
      }

      .dropdown-item {
        padding: 0;
        border-radius: var(--border-radius, 0);

        &:hover {
          transition: transform 0.3s ease-in-out;
          transform: scale(1.1);
        }
      }

      .basemap-item-selected {
        border-radius: var(--border-radius, 0);
        border: 3px solid $primary !important;
      }
    }

    .basemap-selector__dropdown {
      background-color: transparent !important;
      border-radius: var(--border-radius, 0);
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      max-width: 40px !important;

      display: flex;
      align-items: center;
      justify-content: center;

      &::after {
        display: none !important;
      }

      .basemap-selector__dropdown-toggle {
        width: 40px !important;
        height: 40px !important;
        min-width: 40px !important;
        max-width: 40px !important;
        padding: 0;
        background-color: transparent !important;
        border: none;
        box-shadow: none;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .basemap-selector__dropdown-toggle::after {
      display: none !important;
    }
  }

  .basemap-selector__image {
    width: 80px;
    height: 80px;
    border-radius: var(--border-radius, 0);
  }
}

@keyframes expand {
  0% {
    border-radius: 20px;
    transform: scale(1);
  }
  50% {
    border-radius: 10px;
    transform: scale(1.05);
  }
  100% {
    border-radius: 4px;
    transform: scale(1.1);
  }
}
</style>
